const lightPrimaryColor = '#80939C';

export const MuiSwitch = {
  styleOverrides: {
    root: {
      '.MuiSwitch-switchBase': {
        '&.Mui-checked': {
          color: '#00283A',
          '+.MuiSwitch-track': {
            backgroundColor: lightPrimaryColor,
          },
        },
      },
    },
  },
};
